(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hbni-announcement"]) return;
  try {
    
(() => {
 const key='hbni-region-selected';
 const remember=()=>{try{localStorage.setItem(key,'1')}catch{}};
 document.addEventListener('submit',e=>{if(e.target.action?.includes('/localization'))remember()},true);
 document.addEventListener('click',e=>{if(e.target.closest('[data-country-code], [data-value]'))remember()},true);
 const form=document.getElementById('hbni-auto-region');
 if(!form)return;
 form.hidden=true;
 try{if(localStorage.getItem(key))return}catch{return}
 if(new URLSearchParams(location.search).has('country')){remember();return}
 remember();
 const current=form.elements.country_code.value;
 fetch(window.Shopify.routes.root+'browsing_context_suggestions.json?country[enabled]=true&country[exclude]='+encodeURIComponent(current))
 .then(r=>r.ok?r.json():null).then(data=>{
  const country=data?.suggestions?.[0]?.parts?.country;
  if(country?.handle&&country.handle!==current&&country.confidence>=0.9){
   form.elements.country_code.value=country.handle;
   form.submit();
  }
 }).catch(()=>{});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
